import { render, staticRenderFns } from "./recipeCategories.vue?vue&type=template&id=6fcc7842&"
import script from "./recipeCategories.vue?vue&type=script&lang=js&"
export * from "./recipeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports